/** Pestañas de reseñas (A14) y vídeos que solo se reproducen cuando se ven (A15, E11). */
class LaPestanas extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const b = e.target.closest('[role="tab"]');
      if (b) this.abrir(b.dataset.tab);
    });
  }

  abrir(tab) {
    let hay = false;
    for (const b of this.querySelectorAll('[role="tab"]')) {
      const sel = b.dataset.tab === tab;
      b.setAttribute('aria-selected', String(sel));
      hay ||= sel;
    }
    if (!hay) return;
    for (const p of this.querySelectorAll('[role="tabpanel"]')) p.hidden = p.dataset.panel !== tab;
  }
}
if (!customElements.get('la-pestanas')) customElements.define('la-pestanas', LaPestanas);

// Enlaces que abren una pestaña concreta (A13 → "Piel grasa").
document.addEventListener('click', (e) => {
  const a = e.target.closest('[data-la-tab]');
  if (a) document.querySelector('la-pestanas')?.abrir(a.dataset.laTab);
});

// Vídeos: se cargan y reproducen solo en pantalla; se pausan al salir.
if (!window.laVideosObservados) {
  window.laVideosObservados = true;
  const io = new IntersectionObserver(
    (entradas) => {
      for (const { target: v, isIntersecting } of entradas) {
        if (isIntersecting) {
          v.muted = true;
          v.play().catch(() => {});
        } else v.pause();
      }
    },
    { threshold: 0.5 }
  );
  const observar = () => document.querySelectorAll('video[data-la-autoplay], .la-guia video').forEach((v) => io.observe(v));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observar);
  else observar();
}

// E9 · Botón de las tarjetas de colección: siempre con texto y precio ("AÑADIR AL CARRITO · 60 €").
const laTextoTarjetas = () => {
  for (const card of document.querySelectorAll('product-card, .product-card')) {
    const boton = card.querySelector('[ref="addToCartButton"]');
    const precio = card.querySelector('.price, [ref="priceContainer"] .price, .price-item');
    if (!boton || !precio) continue;
    const valor = precio.textContent.trim().replace(/\s+/g, ' ').replace(',00', '').replace('€', '').trim();
    const texto = `AÑADIR AL CARRITO · ${valor} €`;
    const el = boton.querySelector('.add-to-cart-text__content') || boton;
    if (el.textContent.trim() !== texto) el.textContent = texto;
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', laTextoTarjetas);
else laTextoTarjetas();

// E1 · Altura real de la barra superior fija (Horizon suma la cabecera en --header-group-height).
const laTopbar = () => {
  if (!document.body.classList.contains('la-topbar-fija')) return;
  const barra = document.querySelector('#header-group > .shopify-section:first-child:not(.header-section)');
  document.body.style.setProperty('--la-topbar-alto', `${barra ? barra.offsetHeight : 0}px`);
};
laTopbar();
window.addEventListener('resize', laTopbar);
